import { createApp } from 'vue'
import router from './router/router.config'
import store from './store'
import 'ant-design-vue/es/message/style/index'
import App from './App'
import VueI18n from 'vue-i18n'
import mitt, { Emitter } from 'mitt'
import langEN from './common/lang/en-us'
import langCN from './common/lang/zh-cn'

const app = createApp(App)
// 添加eventbus总线
app.config.globalProperties.$EventBus = mitt() as Emitter<any>
app.use(router).use(store).mount('#app')
